module.exports = __webpack_public_path__ + "img/사당 술집.4780053e.png";